import { canNavigate } from "@plugins/casl/casl";
import { store } from "@store";
import { cookies } from "@/plugins/useCookies";
import { emitter } from "@plugins/mitt";
import { useStorage } from "@vueuse/core";

export const setupGuards = (router) => {
  // 👉 router.beforeEach
  // Docs: https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards
  router.beforeEach((to) => {
    /*
     * If it's a public route, continue navigation. This kind of pages are allowed to visited by login & non-login users. Basically, without any restrictions.
     * Examples of public routes are, 404, under maintenance, etc.
     */
    if (to.meta.public) return true;

    // const authStore = useAuthStore(store);

    /**
     * Check if user is logged in by checking if token & user data exists in local storage
     * Feel free to update this logic to suit your needs
     */
    // const userInfo = useStorage(
    //   `NEXUS-${import.meta.env.MODE}-userInfo`,
    //   {},
    //   localStorage
    // );
    const isLoggedIn = !!cookies.get(
      `NEXUS-${import.meta.env.MODE}-accessToken`
    );
    console.log("isLoggedIn", isLoggedIn);

    /*
          If user is logged in and is trying to access login like page, redirect to home
          else allow visiting the page
          (WARN: Don't allow executing further by return statement because next code will check for permissions)
         */
    if (to.meta.unauthenticatedOnly) {
      if (isLoggedIn) return "/";
      else return undefined;
    }

    if (to.meta.requiresAuth && !isLoggedIn) {
      // return { name: "404", query: { redirect: to.fullPath } };
      sessionStorage.setItem("forcedLogin", "1");
      return "/";
    }
  });
};
